<div class="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
  <!-- Table Header -->
  <div class="flex items-center justify-between mb-6">
    <h3 class="text-lg font-semibold text-gray-900">{{ config.title }}</h3>
    <a
      [routerLink]="config.viewAllRoute"
      class="text-red-500 hover:text-red-600 font-medium text-sm transition-colors duration-200"
    >
      View All >
    </a>
  </div>

  <!-- Simple Table -->
  <div
    class="hidden md:block bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden"
  >
    <div class="overflow-hidden">
      <!-- Table Header Row -->
      <div class="bg-slate-800 text-white px-4 py-2 rounded-t-lg">
        <div
          class="grid font-semibold text-sm"
          [ngClass]="type === 'users' ? 'grid-cols-4 gap-4' : 'grid-cols-3 gap-6'"
        >
          @for (column of config.columns; track $index) {
          <div>{{ column }}</div>
          }
        </div>
      </div>

      <!-- Table Body -->
      <div
        class="bg-white hidden md:block rounded-xl shadow-sm border border-gray-100 overflow-hidden"
      >
        @if (type === 'users') { @if (userData.length > 0) { @for (row of
        userData; track $index) {
        <div
          class="grid grid-cols-4 gap-4 px-4 py-2 border-b border-gray-100 hover:bg-gray-50 transition-colors duration-150"
        >
          <div class="text-sm text-gray-900 font-medium">
            {{ row.fullName }}
          </div>
          <div class="text-sm text-gray-600">{{ row.emailAddress }}</div>
          <div class="text-sm text-gray-700">{{ row.userRole }}</div>
          <div class="text-sm text-gray-600">{{ row.createdOn }}</div>
        </div>
        } } @else {
        <div class="text-center py-8 text-gray-500">No Data Available</div>
        } } @else { @if (documentData.length > 0) { @for (row of documentData;
        track $index) {
        <div
          class="grid grid-cols-3 gap-6 px-4 py-2 border-b border-gray-100 hover:bg-gray-50 transition-colors duration-150"
        >
          <div class="text-sm text-gray-600 whitespace-nowrap">{{ row.uploadDate }}</div>
          <div 
            class="text-sm text-blue-600 hover:text-blue-800 underline cursor-pointer font-small truncate pr-4"
            (click)="onDocumentNameClick(row); $event.stopPropagation()"
            title="{{ row.documentName }}"
          >
            {{ row.documentName }}
          </div>
          <div class="flex items-center gap-2">
            <div
              class="w-2 h-2 rounded-full flex-shrink-0"
              [class]="getStatusColor(row.status)"
            ></div>
            <span class="text-sm text-gray-700 whitespace-nowrap">{{ row.status }}</span>
          </div>
        </div>
        } } @else {
        <div class="text-center py-8 text-gray-500">No Data Available</div>
        } }
      </div>
    </div>
  </div>
  <div class="md:hidden">
    <app-card-list
      [data]="type === 'users' ? userData : documentData"
      [context]="type === 'documents' ? 'documents' : type"
      [showActions]="false"
      (documentNameClick)="onDocumentNameClick($event)"
    >
    </app-card-list>

    <!-- Pagination for Mobile -->
  </div>
</div>
